export class TchScaleTemplatesListReadModel 
{
    Templates: DiscreteScaleReadModel[];
}

export class WorkspaceScalesListReadModel 
{
    UserId: number;
    WorkspaceId: number;
    WorkspaceName: string;
    Scales: DiscreteScaleReadModel[];
}


export class DiscreteScaleReadModel 
{
    Id: number;
    Name: string;
    Description: string;
    LevelsDescription: string;
    Levels: DiscreteScaleLevelReadModel[];
}

export class DiscreteScaleLevelReadModel 
{
    Name: string;
    Value: number;
    Definition: string;
    NameError: string;
    ValueError: string;
}




